import Api from "../config/Axios";

export const riderLiveLocationServices = (id) => {
  const config = {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      UserId: parseInt(localStorage.getItem("user_id")),
    },
  };
  return Api.get(`api/web/rider/location/by/store?zones=${id}`, config);
};

